import WebsocketManager from '../network/ws/WebsocketManager';

/**
 * Represents WebsocketManager instance.
 * Responsible to manage controllers websockets connections
 * */
const wsm = new WebsocketManager();

export default wsm;
